import { render } from "./LayOut.vue?vue&type=template&id=a5fad27a"
import script from "./LayOut.vue?vue&type=script&lang=js"
export * from "./LayOut.vue?vue&type=script&lang=js"

import "./LayOut.vue?vue&type=style&index=0&id=a5fad27a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__